import { SellingZoneGraphItem } from '@substratahq/selling-zone/typing/base';
import { Dispatch } from 'redux';
import axios from '../../axios';
import {
  ClearDetailedAnalysisAction,
  DealsTableRow,
  DetailedAnalysisEmail,
  EmailBranch,
  EngagementTableRow,
  GetDealsAction,
  GetDetailedAnalysisAction,
  GetEngagementsAction,
  RenameEngagementAccAction,
  ResetEngPageNumberAction,
  SetCurrentBranchAction,
  SetCurrentDealAction,
  SetCurrentEmailAction,
  SetCurrentThreadAction,
  SetDataSortCaseAction,
  SetGraphItemsAction,
  SetLoadingDeatiledAnalysisAction,
  SetLoadingListAction,
  SetRemoveThreadStatusAction,
  SetSelectedGraphItemAction,
  SubmitFeedbackRequest,
  TableDataSortCase,
  UpdateAccountInfoAction,
  UpdateCrmDataAction,
  UpdateCurrentEmailAction,
  UpdateThreadCompleteAction,
  UserFeedbackType,
} from './deals.types';
import { convertEngagementsForList, mockDataForTable } from './deals.utils';
import { UpperHandFeedbackEnum } from '../../enums/upper-hand-feedback.enum';
import demoDataDetailedView from './mock-data-detailed-view.json';

export const GET_ENGAGEMENTS = 'GET_ENGAGEMENTS';
export const SET_CURRENT_ENGAGEMENT = 'SET_CURRENT_ENGAGEMENT';
export const UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO';

export const RESET_ENG_PAGE_NUMBER = 'RESET_ENG_PAGE_NUMBER';

export const GET_DEALS = 'GET_DEALS';
export const SET_LOADING_LIST = 'SET_LOADING_LIST';
export const SET_CURRENT_DEAL = 'SET_CURRENT_DEAL';
export const REMOVE_THREAD = 'REMOVE_THREAD';
export const SET_REMOVE_THREAD_STATUS = 'SET_REMOVE_THREAD_STATUS';
export const RENAME_ACCOUNT = 'RENAME_ACCOUNT';
export const SET_DATA_SORT_CASE = 'SET_DATA_SORT_CASE';

export const GET_DETAILED_ANALYSIS = 'GET_DETAILED_ANALYSIS';
export const SET_LOADING_DETAILED_ANALYSIS = 'SET_LOADING_DETAILED_ANALYSIS';
export const SET_CURRENT_THREAD = 'SET_CURRENT_THREAD';
export const SET_CURRENT_BRANCH = 'SET_CURRENT_BRANCH';
export const SET_CURRENT_EMAIL = 'SET_CURRENT_EMAIL';
export const UPDATE_CURRENT_EMAIL = 'UPDATE_CURRENT_EMAIL';
export const CLEAR_DETAILED_ANALYSIS = 'CLEAR_DETAILED_ANALYSIS';

export const UPDATE_CRM_DATA = 'UPDATE_CRM_DATA';
export const UPDATE_THREAD_COMPLETE = 'UPDATE_THREAD_COMPLETE';

export const SET_GRAPH_ITEMS = 'SET_GRAPH_ITEMS';
export const SET_SELECTED_GRAPH_ITEM = 'SET_SELECTED_GRAPH_ITEM';

export const setDataSortCase = (sortCase: TableDataSortCase) => (
  dispatch: Dispatch<SetDataSortCaseAction>
): void => {
  dispatch({ type: SET_DATA_SORT_CASE, payload: sortCase });
};

const getAccountInfo = (
  orgId: string,
  userId: string,
  accountId: string
) => async (dispatch: Dispatch<UpdateAccountInfoAction>) => {
  try {
    const accountInfoResponse = await axios.get(
      `services/orgs/${orgId}/users/${userId}/accounts/${accountId}`
    );

    dispatch({
      type: UPDATE_ACCOUNT_INFO,
      payload: accountInfoResponse?.data?.payload,
    });
  } catch (e) {
    // catch error
  }
};

export const getDeals = (
  orgId: string,
  userId: string,
  page: number,
  itemsQty: number,
  sortBy?: 'accountName' | 'lastInteractionDate',
  sortOrder?: 1 | -1
) => async (
  dispatch: Dispatch<
    | GetDealsAction
    | SetLoadingDeatiledAnalysisAction
    | SetLoadingListAction
    | GetEngagementsAction
    | any
  >
): Promise<void> => {
  try {
    dispatch({
      type: SET_LOADING_LIST,
      payload: true,
    });

    const engagementResponse = await axios.get(
      `services/orgs/${orgId}/users/${userId}/engagements?includeInternal=true&page=${page}&ipp=${itemsQty}&sortBy=${
        sortBy || 'lastInteractionDate'
      }&sortOrder=${sortOrder || -1}`
    );

    dispatch({
      type: GET_ENGAGEMENTS,
      payload: {
        engagements: convertEngagementsForList(
          engagementResponse?.data?.payload
        ),
        pagenumber: page,
      },
    });
    if (!engagementResponse?.data?.payload?.results?.length) {
      dispatch({
        type: GET_ENGAGEMENTS,
        payload: {
          engagements: convertEngagementsForList(mockDataForTable),
          pagenumber: 1,
        },
      });
    }

    const accountIds: string[] = engagementResponse?.data?.payload?.results?.map(
      (el: any) => el?.account?.accountId
    );

    const uniqueIds = accountIds?.length
      ? accountIds.filter((element, index) => {
          return accountIds.indexOf(element) === index;
        })
      : [];

    if (uniqueIds.length) {
      uniqueIds.forEach((el) => dispatch(getAccountInfo(orgId, userId, el)));
    }

    dispatch({
      type: SET_LOADING_LIST,
      payload: false,
    });
  } catch (e) {
    dispatch({
      type: SET_LOADING_LIST,
      payload: false,
    });
  }
};

export const resetEngagementPageNumber = (): ResetEngPageNumberAction => ({
  type: RESET_ENG_PAGE_NUMBER,
});

export const setCurrentDeal = (deal: EngagementTableRow | null) => (
  dispatch: Dispatch<SetCurrentDealAction>
): void => {
  dispatch({ type: SET_CURRENT_DEAL, payload: deal });
};

export const removeThreads = (
  orgId: string,
  userId: string,
  engagementIds: string[],
  page: number,
  itemsQty: number,
  sortBy?: 'accountName' | 'lastInteractionDate',
  sortOrder?: 1 | -1
) => async (
  dispatch: Dispatch<
    | UpdateCrmDataAction
    | GetEngagementsAction
    | SetLoadingListAction
    | SetRemoveThreadStatusAction
  >
): Promise<void> => {
  try {
    dispatch({
      type: SET_LOADING_LIST,
      payload: true,
    });

    const enagementsToDelete = {
      op: 'delete',
      engagementIds,
    };

    const removedThreadsResponse = await axios.post(
      `services/orgs/${orgId}/users/${userId}/engagements`,
      enagementsToDelete
    );

    if (removedThreadsResponse.status === 200) {
      dispatch({
        type: SET_REMOVE_THREAD_STATUS,
        payload: 'success',
      });
      const engagementResponse = await axios.get(
        `services/orgs/${orgId}/users/${userId}/engagements?includeInternal=true&page=${page}&ipp=${itemsQty}&sortBy=${
          sortBy || 'lastInteractionDate'
        }&sortOrder=${sortOrder || -1}`
      );

      setTimeout(() => {
        dispatch({
          type: GET_ENGAGEMENTS,
          payload: {
            engagements: convertEngagementsForList(
              engagementResponse.data.payload
            ),
            pagenumber: page,
          },
        });

        dispatch({
          type: SET_LOADING_LIST,
          payload: false,
        });
      }, 1000);
    }
  } catch (e) {
    dispatch({
      type: SET_REMOVE_THREAD_STATUS,
      payload: 'error',
    });
    dispatch({
      type: SET_LOADING_LIST,
      payload: false,
    });
  }
};

export const resetRemovedThreadStatus = (): SetRemoveThreadStatusAction => ({
  type: SET_REMOVE_THREAD_STATUS,
  payload: null,
});

export const renameEngagementAcc = (
  orgId: string,
  userId: string,
  accountId: string,
  newName: string
) => async (dispatch: Dispatch<RenameEngagementAccAction>): Promise<void> => {
  try {
    const body = {
      name: newName,
    };

    const renamedAccResponse = await axios.patch(
      `services/orgs/${orgId}/users/${userId}/accounts/${accountId}`,
      body
    );

    dispatch({
      type: RENAME_ACCOUNT,
      payload: {
        ...renamedAccResponse.data.payload,
        accountId,
      },
    });
  } catch (e) {
    // catch
  }
};

export const getDeatailedAnalysis = (
  orgId: string,
  userId: string,
  engagementId: string,
  branchId: string,
  mock?: boolean
) => async (
  dispatch: Dispatch<
    GetDetailedAnalysisAction | SetLoadingDeatiledAnalysisAction
  >
): Promise<void> => {
  try {
    dispatch({
      type: SET_LOADING_DETAILED_ANALYSIS,
      payload: true,
    });

    if (mock) {
      setTimeout(() => {
        dispatch({
          type: GET_DETAILED_ANALYSIS, // eslint-disable-next-line
          payload: demoDataDetailedView.payload as any, // TODO - REVIEW RESPONSE TYPE
        });

        dispatch({
          type: SET_LOADING_DETAILED_ANALYSIS,
          payload: false,
        });
      }, 2000);
    } else {
      const detailedAnalysysResponse = await axios.get(
        `services/orgs/${orgId}/users/${userId}/engagements/${engagementId}/threads/${branchId}`
      );

      dispatch({
        type: GET_DETAILED_ANALYSIS,
        payload: detailedAnalysysResponse?.data?.payload,
      });

      dispatch({
        type: SET_LOADING_DETAILED_ANALYSIS,
        payload: false,
      });
    }
  } catch (e) {
    dispatch({
      type: SET_LOADING_DETAILED_ANALYSIS,
      payload: false,
    });
  }
};

export const clearDetailedAnalysis = (): ClearDetailedAnalysisAction => ({
  type: CLEAR_DETAILED_ANALYSIS,
});

export const setCurrentThread = (thread: DealsTableRow) => (
  dispatch: Dispatch<SetCurrentThreadAction>
): void => {
  dispatch({ type: SET_CURRENT_THREAD, payload: thread });
};

export const setCurrentBranch = (branch: EmailBranch) => (
  dispatch: Dispatch<SetCurrentBranchAction>
): void => {
  dispatch({ type: SET_CURRENT_BRANCH, payload: branch });
};

export const setCurrentEmail = (emailId: string) => (
  dispatch: Dispatch<SetCurrentEmailAction>
): void => {
  dispatch({ type: SET_CURRENT_EMAIL, payload: emailId });
};

export const sendViewEmail = (
  orgId: string,
  userId: string,
  engagementId: string,
  emailId: string // eslint-disable-next-line
) => (dispatch: Dispatch): void => {
  try {
    const postBody = {
      platformMessageIds: [emailId],
    };

    axios.post(
      `services/orgs/${orgId}/users/${userId}/threads/${engagementId}/viewed-emails`,
      postBody
    );

    // eslint-disable-next-line
  } catch (e) {
    // catch-err
  }
};

export const updateCurrentEmail = (email: DetailedAnalysisEmail) => (
  dispatch: Dispatch<UpdateCurrentEmailAction>
): void => {
  dispatch({ type: UPDATE_CURRENT_EMAIL, payload: email });
};

export const setGraphItems = (graphItems: SellingZoneGraphItem[]) => (
  dispatch: Dispatch<SetGraphItemsAction>
): void => {
  dispatch({ type: SET_GRAPH_ITEMS, payload: graphItems });
};

export const setSelectedGraphItem = (graphItemId: number) => (
  dispatch: Dispatch<SetSelectedGraphItemAction>
): void => {
  dispatch({ type: SET_SELECTED_GRAPH_ITEM, payload: graphItemId });
};

export const updateCrmData = (
  orgId: string,
  userId: string,
  platformThreadId: string,
  itemsToUpdate: {
    dealName?: string;
    crmStage?: string;
    dealValue?: string;
  }
) => async (dispatch: Dispatch<UpdateCrmDataAction>): Promise<void> => {
  try {
    // eslint-disable-next-line
    const valuesToUpdate: any = {}; // eslint-disable-next-line
    for (const [key, value] of Object.entries(itemsToUpdate)) {
      if (typeof value === 'string') {
        valuesToUpdate[key] = value.trim();
      }
    }

    const dataToUpdate = {
      operations: [
        {
          platformThreadIds: [platformThreadId],
          updateThreadProps: valuesToUpdate,
        },
      ],
    };

    const crmUpdateResponse = await axios.patch(
      `services/orgs/${orgId}/users/${userId}/deals`,
      dataToUpdate
    );
    if (crmUpdateResponse.status === 200) {
      dispatch({
        type: UPDATE_CRM_DATA,
        payload: valuesToUpdate,
      });
    }
  } catch (e) {
    // catch err
  }
};

export const updateThreadComplete = (
  orgId: string,
  userId: string,
  platformThreadId: string,
  flag: boolean
) => async (
  dispatch: Dispatch<UpdateThreadCompleteAction | GetDetailedAnalysisAction>
): Promise<void> => {
  try {
    const dataToUpdate = {
      operations: [
        {
          platformThreadIds: [platformThreadId],
          updateThreadProps: {
            isCompleted: flag,
          },
        },
      ],
    };

    const threadCompleteResponse = await axios.patch(
      `services/orgs/${orgId}/users/${userId}/deals`,
      dataToUpdate
    );
    if (threadCompleteResponse.status === 200) {
      dispatch({
        type: UPDATE_THREAD_COMPLETE,
      });

      const detailedAnalysysResponse = await axios.post(
        `services/orgs/${orgId}/users/${userId}/deals/${platformThreadId}/detailed-analysis`
      );

      dispatch({
        type: GET_DETAILED_ANALYSIS,
        payload: detailedAnalysysResponse.data.payload,
      });
    }
  } catch (e) {
    // catch err
  }
};

export const submitFeedback = (
  orgId: string,
  userId: string,
  platformThreadId: string,
  selectedEmail: DetailedAnalysisEmail,
  feedback: UpperHandFeedbackEnum
) => async (dispatch: Dispatch<UpdateCurrentEmailAction>): Promise<void> => {
  try {
    const model: SubmitFeedbackRequest = {
      orgId,
      userId,
      emailId: selectedEmail?.messageId,
      platformMessageId: selectedEmail?.platformMessageId,
      platformThreadId,
      type: UserFeedbackType.UPPER_HAND,
      feedback: feedback === UpperHandFeedbackEnum.CORRECT,
    };

    await axios.post(`services/orgs/${orgId}/users/${userId}/feedback`, model);

    const selectedEmailToSet = selectedEmail;
    selectedEmailToSet.upperHandFeedback = feedback;

    dispatch({
      type: UPDATE_CURRENT_EMAIL,
      payload: selectedEmailToSet,
    });
  } catch (e) {
    // catch err
  }
};
